module.exports = __webpack_public_path__ + "static/outlook_web_2-5668657f68cb5154add2225ee14dbe0d.png";